import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../theme';

const { colors } = redesignTheme;

export const useHomePageStyles = makeStyles(() => ({
  page: {
    width: '100%',
    minHeight: '100%',
    backgroundColor: colors.background,
    boxSizing: 'border-box',
  },
}));
